import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type HeaderAction = "menu" | "save" | "none";
export type ColorMode = "unicolor" | "color";
export type WidthMode = "full" | "half";

export interface SaveState {
  isDialogOpen: boolean;
}

export interface MenuState {
  color: string;
  isMenuOpen: boolean;
}

export interface HeaderState {
  action: HeaderAction;
  colorMode: ColorMode;
  widthMode: WidthMode;
  save: SaveState;
  menu: MenuState;
}

const initialState: HeaderState = {
  action: "save",
  colorMode: "unicolor",
  widthMode: "full",
  save: {
    isDialogOpen: false,
  },
  menu: {
    isMenuOpen: false,
    color: "#ffffff",
  },
};

export const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setHeaderAction(state, action: PayloadAction<HeaderAction>) {
      state.action = action.payload;
    },
    setHeaderColorMode(state, action: PayloadAction<ColorMode>) {
      state.colorMode = action.payload;
    },
    setHeaderMenuColor(state, action: PayloadAction<string>) {
      state.menu.color = action.payload;
    },
    setHeaderWidthMode(state, action: PayloadAction<WidthMode>) {
      state.widthMode = action.payload;
    },
    setIsMenuOpen(state, action: PayloadAction<boolean>) {
      state.menu.isMenuOpen = action.payload;
    },
    setIsSaveDialogOpen(state, action: PayloadAction<boolean>) {
      state.save.isDialogOpen = action.payload;
    },
  },
});

export const {
  setHeaderAction,
  setHeaderColorMode,
  setHeaderMenuColor,
  setHeaderWidthMode,
  setIsMenuOpen,
  setIsSaveDialogOpen,
} = headerSlice.actions;

export default headerSlice.reducer;
